import { temAcesso } from '@/shared/auth/temAcesso'

const Convenios = () => import('./ConvenioLista.vue')
const Detalhes = () => import('./ConvenioDetalhes.vue')

export default {
    path: 'gescon/gestor/convenios',
    name: 'Gescon_Convenios_Gestor',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-GEST-CONV-00')) {
            next()
        }
    },
    children: [
        {
            path: '/gescon/gestor/convenios',
            name: 'Gescon_Convenios_Gestor',
            component: Convenios,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-GEST-CONV-00')) {
                    next()
                }
            }
        },
        {
            path: '/gescon/gestor/convenios/detalhes/:idConvenio',
            name: 'Gescon_Convenios_Gestor_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-GEST-CONV-00')) {
                    next()
                }
            }
        }
    ]
}
